export default __webpack_public_path__ + "static/media/whatsapp.d3f5ab1e.svg";